import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
// import eventBus   from    '@/plugins/eventBus'

const Methods = {

    data() {
        return {
            notyf,
        }
    },

    watch: {
        // form_data: {
        //     handler()
        //     {
        //         if(!this.first_time_search)
        //         {
        //             eventBus.$emit('showToast')
        //         }
        //     },
        //     deep: true
        //  },

        async 'form_data.building_id'(val)
        {
            if(val && val.length)
            {
                let http_request = {
                    id:             val,
                    type_request:   'building',
                }

                const response = await this.get(`${this.rest_api_search}/${JSON.stringify(http_request)}`);
                if(response.status)
                {
                    this.array_options['level_id'] = response.data
                    
                }
                else
                {
                    this.array_options['level_id'] = []
                    this.error_handling(response)
                }

                this.removeOldItems('level_id')
            }
            else
            {
                this.array_options['level_id'] = []
                this.removeOldItems('level_id')
            }
        },

        async 'form_data.level_id'(val)
        {
            
            if(val && val.length)
            {
                let http_request = {
                    id:             val,
                    type_request:   'level',
                }
                const response = await this.get(`${this.rest_api_search}/${JSON.stringify(http_request)}`);
                if(response.status)
                {  
                    this.array_options['area_id'] = response.data
                }
                else
                {
                    this.array_options['area_id'] = []
                    this.error_handling(response)
                }

                this.removeOldItems('area_id')
            }
            else
            {
                this.array_options['area_id'] = []
                this.removeOldItems('area_id')
            }
        },
        
        async 'form_data.radio'(val)
        {
            this.form_data.task_id = ''
            this.form_data.frequency = ''
            const result = this.tasks.filter(item => 
                {
                    if(val == 'projects')
                    {
                        return (item.project === true && item.policing === false)
                    }
                    else if(val == 'daily')
                    {
                        return (item.project === false && item.policing === false)
    
                    }
                    else if(val == 'policing')
                    {
                        return (item.project === false && item.policing === true)
    
                    }
                    else
                    {
                        return item
                    }
                })

                this.array_option = { ...this.array_option, task_id: result }
        },
    },


    methods: {
        applySearch()
        {
            let keys = Object.keys(this.form_data);
                
            keys.forEach(item => 
            {
                this.$refs.main_table.params[item] = this.form_data[item]
            });

            this.$refs.main_table.params['page'] = 1;
            this.fetchMainList(this.$refs.main_table.params)
        },
        
        async removeOldItems(key) 
        {
            this.form_data[key] = this.form_data[key].filter(item => {
                return this.array_options[key].some(array_option => array_option.id === item);
            });
        },
       
        returnedRoomsToParent(withoutChecking = false)
        {
            console.log(withoutChecking)
            
            if(this.room_tasks.length)
            {
                return {...this.$refs.main_table.returnSelection(), params: this.$refs.main_table.params}
            }
            return null
        },

        selectAllBoxes()
        {
            if(this.rooms.length)
            {
                this.rooms.map((item) => {
                    item.checked = this.selectAll
                })
            }
        },

        fill_data(data)
        {
            this.$emit('passInitialData', data)

            this.tasks = data.tasks

            this.array_options = {
                building_id:    data.buildings,
                level_id:       '',
                area_id:        '',
                task_id:        data.tasks,
                room_type_id:   data.room_types,
                floor_id:       data.floors,
                cost_center_id: data.cost_centers,
                group_id:       data.groups,
                frequency_id:   data.frequencies,
                daily_assignment_id: data.daily_assignments ? data.daily_assignments : [],
            }

        },

        async firstRequest()
        {
            if(this.default_filters && this.default_filters.length)
            {
                let form_data = {...this.form_data}

                this.default_filters.forEach(element => 
                {
                    form_data[element.key] = element.value
                });

                this.form_data = form_data
            }

            setTimeout(() => {
                this.first_time_search = false
            }, 400);

        }

    },

}

export default Methods